import { SITE, abs } from "./site";

type SeoArgs = {
  title: string;
  description: string;
  path: string;
  image?: string;
  type?: "website" | "article";
  noindex?: boolean;
};

export function seoMeta(args: SeoArgs) {
  const title = args.title.includes("LexAIPro") ? args.title : `${args.title} - LexAIPro`;
  const image = args.image ?? SITE.ogImage;
  const url = abs(args.path);
  const meta: Array<Record<string, string>> = [
    { title },
    { name: "description", content: args.description },
    { property: "og:title", content: title },
    { property: "og:description", content: args.description },
    { property: "og:type", content: args.type ?? "website" },
    { property: "og:url", content: url },
    { property: "og:image", content: image },
    { property: "og:locale", content: SITE.locale },
    { property: "og:site_name", content: SITE.name },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: args.description },
    { name: "twitter:image", content: image },
  ];
  if (args.noindex) meta.push({ name: "robots", content: "noindex,nofollow" });
  return {
    meta,
    links: [
      { rel: "canonical", href: url },
      { rel: "alternate", hrefLang: "it-IT", href: url },
      { rel: "alternate", hrefLang: "x-default", href: url },
    ],
  };
}
